export const SCENE_INTERACTION = {
  USER_SCENE_CHANGED: "USER_SCENE_CHANGED",
  USER_MOOD_CHANGED: "USER_MOOD_CHANGED",
  USER_TAKES_SEAT: "USER_TAKES_SEAT",
  TOUR_TAKE_SEAT: "TOUR_TAKE_SEAT",
  USER_TAKES_SEAT_EMPTY: "USER_TAKES_SEAT_EMPTY",
  USER_LEAVES_SEAT: "USER_LEAVES_SEAT",
  TOUR_LEAVE_SEAT: "TOUR_LEAVE_SEAT",
  SET_OCCUPIED_SEATS: "SET_OCCUPIED_SEATS",
  SCENE_INITIALISED: "SCENE_INITIALISED",
  NEW_SCENE_INITIALISED: "NEW_SCENE_INITIALISED",
  JUMP_TO_USER: "JUMP_TO_USER",
  JUMP_TO_OBJECT: "JUMP_TO_OBJECT",
  JUMP_TO_SCENE: "JUMP_TO_SCENE",
  START_ANIMATION: "START_ANIMATION",
  STOP_ANIMATION: "STOP_ANIMATION",
  USER_AVATAR_CHANGED: "USER_AVATAR_CHANGED",
  USER_FRIEND_ADDED: "USER_FRIEND_ADDED",
  USER_FRIEND_REMOVED: "USER_FRIEND_REMOVED",
  SOCKET_USER_INFO_CHANGED: "SOCKET_USER_INFO_CHANGED",
  SOCKET_USER_INFO_CHANGE_REQUESTED: "SOCKET_USER_INFO_CHANGE_REQUESTED",
  USER_VIDEO_STATE_CHANGED: "USER_VIDEO_STATE_CHANGED",
  CUSTOM_CHANGE_SCENE: "CUSTOM_CHANGE_SCENE",
  LOCK_SCENE: "LOCK_SCENE",
  UNLOCK_SCENE: "UNLOCK_SCENE",
  SET_LOCKED_ROOMS: "SET_LOCKED_ROOMS",
  PLAY_SOUND: "PLAY_SOUND",
  USER_TAKES_SCREEN: "USER_TAKES_SCREEN",
  USER_STOP_SCREEN: "USER_STOP_SCREEN",
  USER_SCREEN_SHARE_STATE_CHANGED: "USER_SCREEN_SHARE_STATE_CHANGED",
  SHOW_ELEMENTS: "SHOW_ELEMENTS",
  HIDE_ELEMENTS: "HIDE_ELEMENTS",
  JUMP_TO_USER_EVENT: "JUMP_TO_USER_EVENT",
  NEW_GUEST_ON_PUBLIC_STAGE: "NEW_GUEST_ON_PUBLIC_STAGE",
  NEW_USER_ON_PUBLIC_STAGE: "NEW_USER_ON_PUBLIC_STAGE",
  NEW_STREAM_ON_PUBLIC_STAGE: "NEW_STREAM_ON_PUBLIC_STAGE",
  USER_TAKES_SCREEN_SHARE_SEAT: "USER_TAKES_SCREEN_SHARE_SEAT",
  CHAT_PANEL_OPENED: "CHAT_PANEL_OPENED",
  CHAT_PANEL_CLOSED: "CHAT_PANEL_CLOSED",
  PEOPLE_PANEL_OPENED: "PEOPLE_PANEL_OPENED",
  PEOPLE_INFO_OPENED: "PEOPLE_INFO_OPENED",
  PEOPLE_PANEL_CLOSED: "PEOPLE_PANEL_CLOSED",

  SET_OCCUPIED_SCREENS: "SET_OCCUPIED_SCREENS",
  SET_OCCUPIED_SCREEN_SHARE_SEATS: "SET_OCCUPIED_SCREEN_SHARE_SEATS",
  USER_LEAVES_SCREEN_SHARE: "USER_LEAVES_SCREEN_SHARE",
  USER_TOGGLE_CAMERA_ON_CTA_MENU: "USER_TOGGLE_CAMERA_ON_CTA_MENU",
  STOP_VIDEO_ON_CLICK: "STOP_VIDEO_ON_CLICK",

  ///TOUR
  TOUR_MODE_USER_SCREEN_SHARE_SEAT_STAND_UP: "TOUR_MODE_USER_SCREEN_SHARE_SEAT_STAND_UP",
  TOUR_SET_OCCUPIED_SCREEN_SHARE_SEATS: "TOUR_SET_OCCUPIED_SCREEN_SHARE_SEATS",
  STREAM_RECIEVED: "STREAM_RECIEVED",
  SCREEN_SHARE_STREAM_RECIEVED: "SCREEN_SHARE_STREAM_RECIEVED",
  STREAM_REMOVED: "STREAM_REMOVED",
  STREAM_GUIDE_RECIEVED: "STREAM_GUIDE_RECIEVED",
  TOUR_MODE_STARTED_PUBLISHING: "TOUR_MODE_STARTED_PUBLISHING",
  KILL_GUEST_MODE_SOCKET_REQUEST: "KILL_GUEST_MODE_SOCKET_REQUEST",
  TOUR_MODE_USER_TAKES_SCREEN_SHARE_SEAT: "TOUR_MODE_USER_TAKES_SCREEN_SHARE_SEAT",

  ///ELEMENTS
  PLAY_ALL_VIDEOS_IN_VIDEO_GALLERY: "PLAY_ALL_VIDEOS_IN_VIDEO_GALLERY",
  TAKE_FIRST_EMPTY_SEAT: "TAKE_FIRST_EMPTY_SEAT",
  ///
  USER_CLICKED_STOP_SCREEN_SHARE_BUTTON_IN_MEETING_MODE: "USER_CLICKED_STOP_SCREEN_SHARE_BUTTON_IN_MEETING_MODE",

  /** Request to end VAPI agent call; chair listens and runs confirm + stop when this agent is active. */
  END_VAPI_CALL: "end_VAPI_CALL",
};

export const SHOW_MODAL = {
  SELF_CHECK: "SELF_CHECK",
};
